import clsx from "clsx";
import React from "react";
import { makeStyles } from "tss-react/mui";

import { styled } from "@mui/material/styles";
import { PageContentWrapper } from "@shared/PageContentWrapper/PageContentWrapper";

const PageContainerBase = styled("div")(({ theme }) => ({
    width: "100%",
    minHeight: "100vh",
    overflow: "hidden",
    padding: theme.spacing(8),
    paddingTop: theme.spacing(10),
    flexGrow: 1,
    backgroundColor: theme.palette.emteria.background.default,

    [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2, 2),
    },
}));

const useStyles = makeStyles()({
    fitViewport: {
        height: "100vh",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
    },
});

type PageContainerProps = React.ComponentProps<typeof PageContainerBase> & {
    /** Bounds the container to the viewport height so children can use flex-fill layouts (sticky headers, pinned footers). */
    fitViewport?: boolean;
    /**
     * When false, caps the container at 1024px and centers it instead of stretching full width.
     * Use for admin form pages that should read as a compact column rather than stretching input fields
     * across the whole viewport. Defaults to true (full width) for tables/full-width pages.
     */
    fullWidth?: boolean;
};

export const PageContainer = ({ className, fitViewport, fullWidth = true, children, ...rest }: PageContainerProps) => {
    const { classes } = useStyles();

    return (
        <PageContainerBase {...rest} className={clsx(className, fitViewport && classes.fitViewport)}>
            {fullWidth ? children : <PageContentWrapper size="compact">{children}</PageContentWrapper>}
        </PageContainerBase>
    );
};
